export default {
  path: '/v5/blast',
  name: 'V5_blast',
  component: () => import('./BlastPage.vue'),
};
